export default function XML_Display() {
  return (
    <div>
      <h1>XML_Display</h1>
      <p>This is the XML_Display component.</p>
    </div>
  );
}